/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface SecteurMetierLiesSearch
 */
export interface SecteurMetierLiesSearch {
    /**
     * 
     * @type {string}
     * @memberof SecteurMetierLiesSearch
     */
    codesecteur?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecteurMetierLiesSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SecteurMetierLiesSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SecteurMetierLiesSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SecteurMetierLiesSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SecteurMetierLiesSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SecteurMetierLiesSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SecteurMetierLiesSearch interface.
 */
export function instanceOfSecteurMetierLiesSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SecteurMetierLiesSearchFromJSON(json: any): SecteurMetierLiesSearch {
    return SecteurMetierLiesSearchFromJSONTyped(json, false);
}

export function SecteurMetierLiesSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecteurMetierLiesSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codesecteur': !exists(json, 'codesecteur') ? undefined : json['codesecteur'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SecteurMetierLiesSearchToJSON(value?: SecteurMetierLiesSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codesecteur': value.codesecteur,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

